const types = {
  GET_SESSION_TOKEN: '@@PO_session/GET_SESSION_TOKEN',
  SET_SESSION_DATA: '@@PO_session/SET_SESSION_DATA',
};

export default types;
